import * as Marquees from "@/services/marketingManagementService/marquees";

export default {
  Marquees,
};
